<template>
  <container>
    <v-card>
      <v-app-bar flat>
        <v-toolbar-title class="font-weight-medium">Produtos</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-menu
          offset-y
          v-model="open_advanced_filter"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-badge :value="filtered_advanced" color="red" dot overlap>
              <v-btn v-bind="attrs" v-on="on" icon small>
                <v-icon v-if="!open_advanced_filter"
                  >mdi-filter-menu-outline</v-icon
                >
                <v-icon v-else>mdi-filter-minus-outline</v-icon>
              </v-btn>
            </v-badge>
          </template>
          <v-form @submit.prevent="handleAdvanceFilter()">
            <v-card flat class="menu">
              <v-card-title>Filtros Avançados</v-card-title>
              <v-card-text>
                <v-row no-gutters class="align-center">
                  <v-col cols="12" md="3">Preço</v-col>
                  <v-col>
                    <div class="d-flex">
                      <vuetify-money
                        v-model="advanced_filter.min_price"
                        class="mr-2"
                        name="price"
                        type="text"
                        :options="money"
                        placeholder="Mínimo"
                      />
                      <vuetify-money
                        v-model="advanced_filter.max_price"
                        name="price"
                        type="text"
                        :options="money"
                        placeholder="Máximo"
                      />
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters class="align-center">
                  <v-col cols="12" md="3">Tipo de Produto</v-col>
                  <v-col>
                    <local-category-select
                      :category="advanced_filter.local_category"
                      @change="advanced_filter.local_category = $event"
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters class="align-center">
                  <v-col cols="12" md="3">Categoria Externa</v-col>
                  <v-col>
                    <category-select
                      placeholder="Selecione uma categoria"
                      :category="advanced_filter.category"
                      @change="advanced_filter.category = $event"
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters class="align-center">
                  <v-col cols="12" md="3">Marca</v-col>
                  <v-col>
                    <brand-select
                      :brand="advanced_filter.brand"
                      @change="advanced_filter.brand = $event"
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters class="align-center">
                  <v-col cols="12" md="3">Loja</v-col>
                  <v-col>
                    <store-select
                      :store="advanced_filter.store"
                      @change="advanced_filter.store = $event"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="handleResetFilter" text>Limpar</v-btn>
                <v-btn type="submit" color="primary">Pesquisar</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-menu>
        <v-btn icon @click="getProducts()" :loading="loading">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="filter"
          append-icon="mdi-magnify"
          label="Pesquisar produtos"
          style="max-width: 350px"
          single-line
          hide-details
          clearable
          @click:append="getProducts"
          @keydown.enter="getProducts"
        >
        </v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="products"
        :disabled="loading"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        loading-text="A carregar..."
        fixed-header
        height="65vh"
      >
        <template v-slot:item.image_url="{ item }">
          <v-avatar tile size="62">
            <v-img :src="item.image_url"></v-img>
          </v-avatar>
        </template>
        <template v-slot:item.price="{ item }">
          {{ parseMoney(item.price) }}
        </template>
        <template v-slot:item.local_category="{ item }">
          <ScopeProvider scope="products.edit_local_category">
            <local-category-select
              :category="item.local_category"
              @change="setLocalCategory(item, $event)"
              creatable
            />
            <template v-slot:not>
              {{ item.local_category.name }}
            </template>
          </ScopeProvider>
        </template>
        <template v-slot:item.store="{ item }">
          <v-chip
            v-if="item.store && item.url"
            :href="item.url"
            target="_blank"
            link
          >
            <v-icon small left>mdi-open-in-new</v-icon>
            {{ item.store }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </container>
</template>

<script>
import {
  changeLocalCategory,
  index as indexProducts,
} from "../services/products";
import ScopeProvider from "../components/ScopeProvider";
import LocalCategorySelect from "../components/autocompletes/LocalCategorySelect";
import CategorySelect from "../components/autocompletes/CategorySelect";
import BrandSelect from "../components/autocompletes/BrandSelect";
import StoreSelect from "../components/autocompletes/StoreSelect";
import money_tool from "@/tools/money";

export default {
  name: "products",
  components: {
    LocalCategorySelect,
    CategorySelect,
    BrandSelect,
    StoreSelect,
    ScopeProvider,
  },
  data: () => ({
    loading: false,
    money: {
      prefix: "€ ",
      suffix: "",
      precision: 2,
      length: 11,
      locale: "pt-PT",
    },
    open_advanced_filter: false,
    filtered_advanced: false,
    advanced_filter: {
      min_price: null,
      max_price: null,
      local_category: null,
      category: null,
      brand: null,
      store: null,
    },
    filter: "",
    products: [],
    options: {},
    totalItems: 0,
    headers: [
      {
        text: "",
        value: "image_url",
        align: "center",
        sortable: false,
      },
      {
        text: "Nome",
        value: "name",
      },
      {
        text: "Preço",
        value: "price",
      },
      {
        text: "Tipo de Produto",
        value: "local_category",
      },
      {
        text: "Categoria Externa",
        value: "category",
      },
      {
        text: "Marca",
        value: "brand",
      },
      {
        text: "Anúncio",
        value: "store",
      },
    ],
  }),
  methods: {
    parseMoney(money) {
      return money_tool.euro(money);
    },
    async setLocalCategory(product, local_category) {
      product.local_category = local_category;
      try {
        const response = await changeLocalCategory(product.id, local_category);
        product = response;
      } catch (e) {
        product.local_category = null;
      }
    },
    hasAdvancedFilter(filter) {
      return (
        !!filter.local_category_id ||
        !!filter.category_id ||
        !!filter.brand_id ||
        !!filter.store_id ||
        !!filter.min_price ||
        !!filter.max_price
      );
    },
    async getProducts() {
      const advanced_filter = {
        min_price: this.advanced_filter.min_price,
        max_price: this.advanced_filter.max_price,
        local_category_id: this.advanced_filter.local_category?.id,
        category_id: this.advanced_filter.category?.id,
        brand_id: this.advanced_filter.brand?.id,
        store_id: this.advanced_filter.store?.id,
      };

      this.products = [];
      this.loading = true;
      try {
        const response = await indexProducts({
          filter: this.filter,
          ...this.options,
          ...advanced_filter,
        });

        this.products = response.data.map((product) => ({
          ...product,
          local_category: {
            id: product.local_category_id,
            name: product.local_category,
          },
        }));

        this.totalItems = response.total;
        this.filtered_advanced = this.hasAdvancedFilter(advanced_filter);
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: "Falha ao carregar produtos",
          color: "red",
        });
      } finally {
        this.loading = false;
      }
    },
    handleAdvanceFilter() {
      this.getProducts();
      this.open_advanced_filter = false;
    },
    handleResetFilter() {
      this.advanced_filter = {
        min_price: null,
        max_price: null,
        local_category: null,
        category: null,
        brand: null,
        store: null,
      };
      this.open_advanced_filter = false;
      this.getProducts();
    },
  },
  created() {
    this.getProducts();
  },
  watch: {
    options: {
      handler() {
        this.getProducts();
      },
      deep: true,
    },
    filter: function (value) {
      if (value == null) this.getProducts();
    },
  },
};
</script>